import Vue from 'vue'

export async function getMateriales(context, [access_token, showload]) {
    try {
       
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'GET',
            url: '/materiales',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            

        })
        context.commit('mat/setMateriales', response.data.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateMaterial(context, [access_token, mat]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/materiales/' + mat.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                material: mat,
               
            }
        })
        if (response.status == 200) {
            context.commit('mat/actListMateriales', response.data, { root: true })
            return response.data
        }
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function createMaterial(context, [access_token, mat]) {
    try {
        
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/materiales',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                material: mat,
               
                
            }
        })
       
       
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function deleteMaterial(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/materialdelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })
       
        if (response.status == 201) {
            context.commit('mat/actDeleteListMateriales', id, { root: true })
        }
       
    } catch (e) {
       
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}












